import { Injectable } from '@angular/core';
import { AuthService } from 'app/services/auth/auth.service';

/**
 * Tells the signed-in user's own projects, chats and artifacts from the ones a shared project shows them.
 * The backend stores the owner's email as `user_id`.
 */
@Injectable({ providedIn: 'root' })
export class DeoOwnershipService {
  constructor(private readonly _authService: AuthService) {}

  /** A row with no owner was built on this client, so it is the user's own. */
  isMine(ownerId: string | null | undefined): boolean {
    const email = this.currentUserEmail();
    if (!ownerId || !email) {
      return true;
    }
    return ownerId.trim().toLowerCase() === email.trim().toLowerCase();
  }

  currentUserEmail(): string {
    return this._authService.getEmail() ?? '';
  }
}
